import React, { useEffect, useState } from "react";
import axios from "../../../../utils/cmsAxios";

const STATUS_LABELS = {
  SENT: "성공 (발송 접수)", FAILED: "실패", PENDING: "발송 대기",
  RETRY: "재시도 대기", PROCESSING: "처리 중", NEEDS_REVIEW: "발송 여부 확인 필요",
  CANCELLED: "발송 취소", SKIPPED: "미발송", SKIPPED_EXPIRED: "서비스 종료로 미발송",
  QUEUED: "발송 큐 등록", UNKNOWN: "상태 확인 필요",
};

export default function HistorySmsDetails({ historyId, formatDateTime }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setLoading(true);
    setError("");
    axios.get(`${process.env.REACT_APP_FASTAPI_ADS_URL}/select/concierge/history/${historyId}/sms`, {
      signal: controller.signal,
    }).then(({ data }) => {
      if (active) setItems(data.items || []);
    }).catch(() => {
      if (active) setError("문자 발송 정보를 불러오지 못했습니다.");
    }).finally(() => {
      if (active) setLoading(false);
    });
    return () => { active = false; controller.abort(); };
  }, [historyId, revision]);

  return (
    <section id={`history-sms-${historyId}`} aria-label="업로드 완료 문자 정보" className="rounded-lg border border-neutral-200 bg-white p-4 text-left text-sm text-neutral-700">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h3 className="font-semibold">업로드 완료 문자 정보</h3>
        <button type="button" disabled={loading} onClick={() => setRevision((value) => value + 1)}
          className="rounded border border-neutral-300 px-3 py-1 text-xs disabled:opacity-50">새로고침</button>
      </div>
      {loading ? <p role="status">문자 정보 불러오는 중...</p> : error ? (
        <p role="alert" className="text-red-600">{error} 새로고침을 눌러 다시 조회해 주세요.</p>
      ) : items.length === 0 ? <p className="text-neutral-500">이 업로드 건의 문자 발송 기록이 없습니다.</p> : items.map((item, index) => (
        <article key={item.outbox_id || `preparation-${index}`} className="mb-3 rounded-lg border border-neutral-200 bg-neutral-50 p-3">
          <dl className="mb-3 grid grid-cols-2 gap-3 text-xs sm:grid-cols-4">
            <div><dt className="text-neutral-500">발송 상태</dt><dd className="mt-1 font-semibold">{STATUS_LABELS[item.status] || "상태 확인 필요"}</dd></div>
            <div><dt className="text-neutral-500">문자 문구</dt><dd className="mt-1">{item.template_code ? `문구 ${item.template_code.slice(-1)}` : "선택 정보 확인 필요"}
              {item.template_code_source === "CURRENT_SELECTION" && <small className="mt-1 block text-neutral-500">현재 선택 문구 · 발송 당시 번호 미저장</small>}
            </dd></div>
            {item.status === "SENT" && <div><dt className="text-neutral-500">발송 일시 (한국시간)</dt><dd className="mt-1">{formatDateTime(item.sent_at)}</dd></div>}
            <div><dt className="text-neutral-500">예약 일시 (한국시간)</dt><dd className="mt-1">{formatDateTime(item.scheduled_at)}</dd></div>
          </dl>
          {item.error && <p className="mb-3 break-words text-xs text-red-600">처리 사유: {item.error}</p>}
          <p className="mb-1 text-xs text-neutral-500">{item.content_is_preview ? "준비 중인 문구 (실제 전송 전)" : "전송 내용"}</p>
          {item.title && <p className="mb-2 font-semibold">{item.title}</p>}
          <p className="whitespace-pre-wrap break-words leading-relaxed">{item.content || "저장된 전송 내용이 없습니다."}</p>
        </article>
      ))}
      <p className="mt-3 text-xs text-neutral-500">조회수 달성 문자는 제외. 성공은 발송업체 접수 기준이며 실제 수신 완료 여부와 다를 수 있습니다.</p>
    </section>
  );
}
